import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Can I try the accounting database for free?',
  answer: 'Yes! Openmart offers a free trial with 100 credits to explore the verified accounting owner database. You can search, filter, and preview verified accounting firm data before committing. Sign up to test the verified data quality, verify email accuracy, and build sample verified accounting email lists at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-700 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'How many accounting businesses are in the US?',
  answer: 'There are over 250,000 accounting firms in the United States, including sole proprietors, small practices, and large accounting firms. Our accounting database tracks CPAs, tax preparers, bookkeepers, and audit specialists across all 50 states with verified owner contact information.'
}, {
  question: 'How accurate is the accounting owner database?',
  answer: 'Our accounting database maintains a 97% accuracy rate for verified emails and phone numbers. We continuously verify accounting owner contacts in real-time to ensure your accounting email list has high deliverability and low bounce rates.'
}, {
  question: 'Can I filter the accounting database by city or state?',
  answer: 'Yes! You can easily build a city-level or state-level accounting database using our platform. Filter by location to find New York accounting firms, California CPAs, Texas tax preparers, or any US city to target local accounting businesses with precision.'
}, {
  question: 'What is included in the accounting email list?',
  answer: "When you buy accounting leads from Openmart, you get the owner or managing partner's name, verified email address, direct phone number, firm name, physical address, website, employee count, estimated revenue, and specialization (CPA, tax prep, bookkeeping, audit)."
}, {
  question: 'How often is the accounting owner database updated?',
  answer: 'The accounting business database is updated weekly. We constantly crawl public records, professional directories, and corporate filings to add new accounting firms and update existing owner contact information in our database of accounting businesses.'
}, {
  question: 'Can I buy accounting leads for specific specializations?',
  answer: 'Absolutely. You can filter the accounting database to find specific types of accounting businesses, such as CPAs, tax preparation services, bookkeeping firms, forensic accountants, or audit specialists. Target exactly the accounting owner contacts you need.'
}, {
  question: 'How do I access the accounting database?',
  answer: 'You can access the accounting owner database directly through the Openmart web platform to build and export accounting email lists, or use our API to integrate accounting owner contacts directly into your CRM or internal tools.'
}, {
  question: 'What cities are included in the accounting database?',
  answer: 'Our accounting database covers all major US cities including New York, Los Angeles, Chicago, Houston, Phoenix, Philadelphia, San Antonio, San Diego, Dallas, San Jose, and hundreds more. Filter by any city to build targeted accounting email lists for local outreach.'
}];
export function AccountingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-341">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342">
        <div className="text-center mb-16" data-id="element-343">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-344">
            Frequently asked <span className="text-blue-600" data-id="element-345">questions</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-346">
            Everything you need to know about our accounting owner database and
            email list
          </p>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-347">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-348">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-349">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-350">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-351" />
                </button>
                <AnimatePresence data-id="element-352">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-353">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-354" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}